import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import ProgressBar from "../../components/ProgressBarWithBackArrow/ProgressBarWithBackArrow";
import "../SignupPages/SignupCommon.css";

const NadPlusPage9: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<string>("");
  const [inputText, setInputText] = useState<string>("");
  const navigate = useNavigate();
  const location = window.location.pathname;
  const isSermorelinPage = location.includes("sermorelin");

  const handleOptionClick = (option: string) => {
    setSelectedOption(option);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInputText(e.target.value);
  };

  const handleNext = () => {
    localStorage.setItem(
      "Please_list_your_current_medications_prescription_and_over_the_counter_and_supplements",
      JSON.stringify({
        key: "Please_list_your_current_medications_prescription_and_over_the_counter_and_supplements",
        value: [selectedOption], // ✅ store as array
        currentMedications: inputText,
      })
    );
    if(isSermorelinPage){
      localStorage.setItem("completed-step-12", "true");
      navigate("/sermorelin/getting-started/step-13");
    }else{
      localStorage.setItem("completed-step-9", "true");
      navigate("/nadplus/getting-started/step-10");
    }
   
  };

  const handleBack = () => {
    if(isSermorelinPage){
      navigate("/sermorelin/getting-started/step-11");
    }else {
      navigate("/nadplus/getting-started/step-8");
    }

  };

  useEffect(() => {
    const step8Completed = localStorage.getItem("completed-step-8");
    const step11Completed = localStorage.getItem("completed-step-11");
    if(isSermorelinPage){
      if (step11Completed) {
        navigate("/sermorelin/getting-started/step-12", { replace: true });
      } else {
        navigate("/sermorelin/getting-started/step-11", { replace: true });
      }
    }else{
    if (step8Completed) {
      navigate("/nadplus/getting-started/step-9", { replace: true });
    } else {
      navigate("/nadplus/getting-started/step-8", { replace: true });
    }
  }
  }, []);

  useEffect(() => {
    const saved = localStorage.getItem(
      "Please_list_your_current_medications_prescription_and_over_the_counter_and_supplements"
    );
    if (saved) {
      const parsed = JSON.parse(saved);
      setSelectedOption(parsed.value?.[0] || ""); // ✅ extract string from array
      setInputText(parsed.currentMedications || "");
    }
  }, []);

  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={isSermorelinPage ? 85 : 80} onBack={handleBack} />
        <div className="signup-content">
          <p className="signup-intro">
            Are you currently on any medications (prescription and
            over-the-counter) and supplements?
          </p>
          <div className="options options-box">
            <label
              className={selectedOption === "Yes" ? "selected" : ""}
              onClick={() => handleOptionClick("Yes")}
            >
              Yes
            </label>
          </div>
          {selectedOption === "Yes" && (
            <>
              <p className="signup-into-sub">
                Please mention your medication.
              </p>
              <textarea
                value={inputText}
                onChange={handleInputChange}
                style={{
                  width: "100%",
                  height: "100px",
                  resize: "vertical",
                  padding: "8px",
                  marginTop: "5px",
                  fontSize: "16px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                }}
              />
            </>
          )}
          <div className="options options-box" style={{ marginTop: "10px" }}>
            <label
              className={selectedOption === "No" ? "selected" : ""}
              onClick={() => handleOptionClick("No")}
            >
              No
            </label>
          </div>

          <button
            className="next-btn sticky-btn"
            onClick={handleNext}
            disabled={
              !selectedOption || (selectedOption === "Yes" && !inputText)
            }
          >
            Continue →
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default NadPlusPage9;